import * as lucideIcons from "lucide-react";

export const useIcon = (iconName) => {
  if (!iconName) {
    throw new Error("Icon name is required");
  }

  const Icon = lucideIcons[iconName];
  if (!Icon) {
    throw new Error(`Icon "${iconName}" not found`);
  }
  return Icon;
};
